import { createClient } from '@supabase/supabase-js';

// Get Supabase configuration from environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const supabaseAuthUrl = process.env.REACT_APP_SUPABASE_AUTH_URL;

// Validate required environment variables
if (!supabaseUrl) {
  throw new Error('Missing REACT_APP_SUPABASE_URL environment variable');
}

if (!supabaseAnonKey) {
  throw new Error('Missing REACT_APP_SUPABASE_ANON_KEY environment variable');
}

// Log environment info (without exposing sensitive data)
console.log('🔧 Supabase Client Configuration:', {
  hasUrl: !!supabaseUrl,
  hasKey: !!supabaseAnonKey,
  urlDomain: supabaseUrl ? new URL(supabaseUrl).hostname : 'missing',
  environment: process.env.NODE_ENV || 'development'
});

// Main client for database, storage, etc. (uses original Supabase URL)
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Auth client with custom domain (if provided)
export const supabaseAuth = createClient(
  supabaseAuthUrl || supabaseUrl, 
  supabaseAnonKey
);